import ReactDOM from 'react-dom';
export var measureElement = function (element) {
    var DOMNode = ReactDOM.findDOMNode(element);
    return {
        width: DOMNode === null || DOMNode === void 0 ? void 0 : DOMNode.offsetWidth,
        height: DOMNode === null || DOMNode === void 0 ? void 0 : DOMNode.offsetHeight,
    };
};
// Fetches the user id and name from the wixClient cookie
// Wixclient cookie example - razsaroya27||VERIFIED_OPT_IN|0|1683638743203|1689427543203|9ac2b7f8-0a54-438f-99f9-0ca8b91c7a1f|{}|wix
export var getUserInfoFromCookie = function (cookieStore) {
    if (cookieStore === void 0) { cookieStore = document.cookie; }
    try {
        var wixClient = cookieStore.split(';').find(function (s) { return s.includes('wixClient'); });
        if (!wixClient) {
            return null;
        }
        var info = wixClient.split('=')[1].replace(/^"|"$/g, '').split('|');
        return { name: info[0], userId: info[6] };
    }
    catch (ex) {
        console.warn('Cannot parse wixClient cookie', ex);
        return null;
    }
};
//# sourceMappingURL=utils.js.map